import { cloneDeep, merge } from 'lodash';

import { ENTITY_TYPES } from '#client/utils/businessInfo';

import LLC_CONFIG from './llc';
import PAGES from '../flowPageConfig';

// States that support LLC paid flows
const SUPPORTED_LLC_PAID_STATES = [
  { path: 'texas', abbreviation: 'TX', name: 'Texas' },
  { path: 'florida', abbreviation: 'FL', name: 'Florida' },
  { path: 'california', abbreviation: 'CA', name: 'California' },
  { path: 'north-carolina', abbreviation: 'NC', name: 'North Carolina' },
  { path: 'delaware', abbreviation: 'DE', name: 'Delaware' }
];

const PAID_STATE_FLOWS = SUPPORTED_LLC_PAID_STATES.map(({ path, abbreviation, name }) => {
  // Clone the base LLC config to avoid mutating the original
  const flowConfig = cloneDeep(LLC_CONFIG);
  // Set default values for featureFlags
  flowConfig.featureFlags = {};
  flowConfig.currentExperiment = null;

  // Set a unique ID for each state's flow giving it a unique, state specific path
  flowConfig.id = `llc-state-${path}`;

  // Personalize the flow
  merge(flowConfig.pageConfigs, {
    [PAGES.BUSINESS_INFO.pageComponent]: {
      pageComponentProps: {
        fieldsConfigProps: {
          jurisdictionState: {
            show: true,
            'data-testid': 'business-info-jurisdiction-state',
            disabled: true
          }
        },
        businessInfoFormProps: {
          defaultValues: {
            jurisdictionState: abbreviation
          }
        },
        calloutAssetProps: { name: `business-details-${abbreviation.toLowerCase()}` },
        pageHeaderProps: {
          subtitle: {
            id: `shopping.page.businessInfo.subtitle.paidState`,
            values: {
              stateName: name,
              entityType: ENTITY_TYPES.LLC.label
            }
          }
        }
      }
    },
    [PAGES.CONTACT_INFO.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          calloutAsset: {
            name: `contact-info-${abbreviation.toLowerCase()}`
          }
        }
      }
    },
    [PAGES.BUSINESS_EXPERIENCE.pageComponent]: {
      pageComponentProps: {
        calloutAssetProps: {
          name: `business-experience-${abbreviation.toLowerCase()}`,
          show: true
        }
      }
    },
    [PAGES.BUSINESS_STAGE.pageComponent]: {
      pageComponentProps: {
        calloutAssetProps: {
          name: `business-stage-${abbreviation.toLowerCase()}`,
          show: true
        }
      }
    },
    [PAGES.INDUSTRY.pageComponent]: {
      pageComponentProps: {
        calloutAssetProps: {
          name: `industry-${abbreviation.toLowerCase()}`,
          show: true
        }
      }
    }
  });

  return flowConfig;
});

export default PAID_STATE_FLOWS;
